// services/userApi.js

import apiClient from './apiClient';

// ✅ Get logged-in user account
export const getMyAccount = (accountNumber) => {
  return apiClient.get(`/users/account/me/${accountNumber}`);
};

// ✅ Get passbook (transactions)
//export const getMyTransactions = (accountNumber) => {
//  return apiClient.get(`/users/account/me/${accountNumber}/transactions`);
//};

export const getMyTransactions = (accountNumber, page, limit) => {
  return apiClient.get(
    `/users/account/me/${accountNumber}/transactions?page=${page}&limit=${limit}`
  );
};
